import * as React from 'react';
import Group from '../../presentations/Group';

const GroupContainer = (props: any) => {

  const {data} = props;

  return <div><Group data={data}></Group></div>;
};

export default GroupContainer;
